import "../assets/styles/Home.scss";
import intro from "../assets/images/poster.png";
import scIcon1 from "../assets/images/sc-icon-1.png";
import scIcon2 from "../assets/images/sc-icon-2.png";
import scIcon3 from "../assets/images/sc-icon-3.png";
import scIcon4 from "../assets/images/sc-icon-4.png";
import scIcon5 from "../assets/images/sc-icon-5.png";
import scIcon6 from "../assets/images/sc-icon-6.png";
import scIcon7 from "../assets/images/sc-icon-7.png";
// import scIcon8 from "../assets/images/sc-icon-8.png";
// import scIcon9 from "../assets/images/sc-icon-9.png";
import valueProposition from "../assets/images/valueProposition-img.png";
import thankyou from "../assets/images/thankyou.png";

import { useState } from "react";
import Modal from "../components/Model";
import LeadForm from "../components/LeadForm";
import { faqData } from "../const/faq";

export default function Home() {
  const [showModal, setShowModal] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const [openId, setOpenId] = useState<number | null>(1);
  const [showAll, setShowAll] = useState(false);

  const handleSuccess = () => {
    setShowThankYou(true);
    setTimeout(() => {
      setShowThankYou(false);
      closeModal();
    }, 5000);
  };
  const visibleFaqs = showAll ? faqData : faqData.slice(0, 7);

  return (
    <div className="main-container">
      <div className="marketplace">
        <div className="left-container">
          <p className="heading">
            Welcome to India's Leading <br />
            <span className="gradient-text">Cybersecurity Marketplace</span>
          </p>
          <p className="sub-heading">
            Safeguard against online fraud, identity theft, and cyber risks with
            complete personal cyber insurance
          </p>
          <button onClick={openModal}>Enquire Now</button>
        </div>
        {/* <div className="right-container">
          <img
            src={hasslefreepolicy}
            alt="hasslefreepolicy"
            className="hassle-free-policy"
          />
          <img
            src={expertadvice}
            alt="expertadvice"
            className="expert-advice"
          />
          <img
            src={speedyclaims}
            alt="speedyclaims"
            className="speedy-claims"
          />
          <img className="system-img" src={system} alt="system" />
          <div className="patch"></div>
        </div> */}
      </div>

      <div className="introduction">
        <div className="left-container">
          <div className="image-wrap">
            <video width="344" height="200" controls poster={intro} autoPlay loop muted>
              <source
                src="https://static.pbcdn.in/sme-cdn/video/EVVA_1_Last_Draft.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>

        <div className="right-container">
          <p className="heading">
            An introduction to Cyber <br />
            insurance
          </p>
          <p className="sub-heading">
            Complete cyber protection, beyond just insurance
          </p>
        </div>
      </div>

      <div className="coverage-grid">
        <div className="Features">
          <p className="heading">Comprehensive Service Coverage</p>
          <p className="sub-heading">
            Everything your business needs, covered in one place
          </p>
        </div>

        <div className="card">
          <a className="cards" onClick={openModal}>
            <img src={scIcon1} alt="" />
            <p className="heading">Risk Management</p>
            <p className="sub-heading">
              Identifies and reduces cyber risks through continuous assessment,
              vendor security checks, insider-risk monitoring, and one-time
              external threat scanning.
            </p>
          </a>
          <a className="cards" onClick={openModal}>
            <img src={scIcon2} alt="" />
            <p className="heading">Incident Prevention and Response</p>
            <p className="sub-heading">
              Enables quick detection, containment, and recovery from cyber
              incidents through breach support and preparedness exercises.
            </p>
          </a>
          <a className="cards" onClick={openModal}>
            <img src={scIcon3} alt="" />
            <p className="heading">Cyber Threat Intelligence</p>
            <p className="sub-heading">
              Provides real-time visibility into external threats, leaked data,
              exposed assets, and IP risks with continuous monitoring and
              alerts.
            </p>
          </a>
          <a className="cards" onClick={openModal}>
            <img src={scIcon4} alt="" />
            <p className="heading">Offensive Security Services</p>
            <p className="sub-heading">
              Simulates real-world attacks through red teaming, phishing tests,
              code reviews, and configuration assessments to uncover security
              gaps.
            </p>
          </a>
          <a className="cards" onClick={openModal}>
            <img src={scIcon5} alt="" />
            <p className="heading">Governance and Compliance Services</p>
            <p className="sub-heading">
              Aligns security programs with ISO, NIST, PCI, and privacy
              standards through assessments, documentation support, and expert
              advisory.
            </p>
          </a>
          <a className="cards" onClick={openModal}>
            <img src={scIcon6} alt="" />
            <p className="heading">Secure Systems Design Services</p>
            <p className="sub-heading">
              Designs and deploys secure on-prem and cloud infrastructure with
              network hardening, architecture consulting, and secure
              implementation guidance.
            </p>
          </a>
          <a className="cards" onClick={openModal}>
            <img src={scIcon7} alt="" />
            <p className="heading">Strategic Tie-Ups</p>
            <p className="sub-heading">
              Provides expert-led cybersecurity trainings and business impact
              analysis through specialized partnerships supporting resilience
              and continuity.
            </p>
          </a>
          {/*<a className="cards" onClick={openModal}>
            <img src={scIcon8} alt="" />
            <p className="heading">Advanced Technology and Emerging Security</p>
            <p className="sub-heading">
              AI-powered Solutions, Quantum Security Consulting, Bot Protection,
              Threat Hunting, Supply Chain Security.
            </p>
          </div>
         <a className="cards" onClick={openModal}>
            <img src={scIcon9} alt="" />
            <p className="heading">Cloud and DevSecOps Security</p>
            <p className="sub-heading">
              Multi-cloud Security Posture Management, Container Security,
              DevSecOps Integration.
            </p>
          </div> */}
        </div>
      </div>

      <div className="position">
        <div className="left-container">
          <p className="heading">Value Proposition Bullets</p>
          <p className="sub-heading">Complete coverage, simplified</p>
          <button onClick={openModal}>Enquire Now</button>
        </div>
        <div className="right-container">
          <div className="bottom-text">
            Trusted advisor for prevention, detection, response, and compliance
          </div>
          <img src={valueProposition} alt="" />
        </div>
      </div>

      <div className="FAQ">
        <p className="heading">FAQ's</p>

        <div className="faqContainer">
          {visibleFaqs.map((faq) => (
            <div className="faqList" key={faq.id}>
              <div
                className="questionHeading"
                onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
              >
                <h3>{faq.question}</h3>
                <span
                  className="toggleIcon"
                  onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
                >
                  {openId === faq.id ? "-" : "+"}
                </span>
              </div>
              {openId === faq.id && <p className="listContent">{faq.answer}</p>}
            </div>
          ))}

          {/* Show More / Show Less button */}
          {faqData.length > 4 && (
            <button
              className="showMoreBtn"
              onClick={() => setShowAll((prev) => !prev)}
            >
              {showAll ? "Show Less" : "Show More"}
            </button>
          )}
        </div>
      </div>

      {showModal && (
        <Modal onClose={closeModal}>
          {!showThankYou ? (
            <LeadForm onSuccess={handleSuccess} />
          ) : (
            <div className="thankyou">
              <img src={thankyou} />
              <h3>Thanks for sharing your details with us!</h3>
              <p> We’ll connect with you soon.</p>
            </div>
          )}
        </Modal>
      )}
    </div>
  );
}
